import { useAppSelector } from "@src/store/hooks";

const useProductModal = () => {
  const { openProduct } = useAppSelector(({ cart }) => cart);
  return openProduct;
};

export default useProductModal;
